import {ValidityRequestBody} from '@dms/api/shared';

import {getApiDateString} from 'shared/web';

export const getEmptyValidityItem = (validFrom?: Date): ValidityRequestBody => ({
  roundType: 'ALGEBRAIC',
  roundStep: '0.01',
  validFrom: getApiDateString(validFrom ?? new Date()),
  taxRounding: false,
});
